'use strict';


import { projectMode } from '../../../settings';
import { Sky } from '../../liveAnimations/litemode/sky/Sky';

export class ClearSky {
    constructor () {
        this.active = false;
    }

    enable() {
        this.active = true;

        if (projectMode.LiteMode.isActive()) {
            Sky.setData({clouds: {preset: 0} });
        }
    }

    disable() {
        this.active = false;
    }

}